module.exports = __webpack_public_path__ + "static/media/disturbi.72e9461f.svg";